import { Image, message, Table, Tag } from "antd";
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import { FC, useEffect, useState } from "react";
import { notification } from 'antd';
import moment from "moment-jalaali";
import Actions from "../actions";
import { useNavigate } from "react-router-dom";
import restful, { baseURL } from "../../restful";
import ProductDrower from "../drawers/product-drawer";

interface DataType {
    title: string,
    code: string,
    image: string,
    description: string,
    type: string,
    count: number,
    cost: number,
    unit: string,
    api: string,
    category: string | null,
    published: boolean,
    forTest: boolean,
    createdAt: string,
    updatedAt: string,
    _id: string,
}

interface Params { page?: number; perPage?: number, sortDir: string, sort: string }

const ProducsTable: FC<{ filters: any }> = ({ filters }) => {
    const navigate = useNavigate()
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [items, setItems] = useState<DataType[]>([]);
    const [pagination, setPagination] = useState<TablePaginationConfig>({
        current: 1,
        pageSize: 10,
    });

    const onDeleteAction = (id: string) => {
        restful.delete('/products/' + id)
            .then((res) => {
                fetchData({ sortDir: "desc", sort: "updatedAt", page: pagination.current, perPage: pagination.pageSize })
            })
            .catch((err) => message.error(err.message));
    }

    const onEditAction = () => {
        fetchData({ sortDir: "desc", sort: "updatedAt", page: pagination.current, perPage: pagination.pageSize })

    }

    const columns: ColumnsType<DataType> = [
        { sorter: true, title: 'عنوان', dataIndex: 'title', key: 'title' },
        { sorter: true, title: 'کد', dataIndex: 'code', key: 'code', width: 70, },
        {
            sorter: true, title: 'تعداد', dataIndex: 'count', key: 'count', width: 100,
            render(val) { return val.toLocaleString() }
        },
        // {
        //     width: 90, title: 'تصویر', dataIndex: 'image', key: 'image',
        //     render(val) {
        //         return <Image width={44} src={baseURL + "/" + val} />
        //     },
        // },
        // { sorter: true, title: 'توضیحات', dataIndex: 'description', key: 'description' },
        {
            width: 80,
            sorter: true, title: 'نوع', dataIndex: 'type', key: 'type',
            render(val) {
                if (val == "page") return <Tag color="geekblue">صفحه</Tag>;
                if (val == "post") return <Tag color="pink">پست</Tag>;
                return val
            },
        },
        {
            width: 100,
            sorter: true, title: 'مبلغ', dataIndex: 'cost', key: 'cost',
            render(val) { return val.toLocaleString() }
        },
        {
            width: 80,
            sorter: true, title: 'واحد', dataIndex: 'unit', key: 'unit',
            render(val) {
                if (val == "toman") return <Tag color="green">تومان</Tag>;
                if (val == "coin") return <Tag color="gold">سکه</Tag>;
                return val
            },
        },

        {
            width: 100,
            sorter: true, title: 'ای پی ای', dataIndex: 'api', key: 'api',
            render(val) {
                if (val == "yassocial") return <Tag color="red">یاس</Tag>;
                if (val == "followerma") return <Tag color="gold">فالورما</Tag>;
                return val
            },
        },

        {
            width: 120, ellipsis: true,
            sorter: true, title: 'دسته', dataIndex: 'category', key: 'category',
            render(val) { return val?.title },
        },

        {
            width: 100,
            sorter: true, title: 'تستی', dataIndex: 'forTest', key: 'forTest',
            render(val) {
                if (val) return <Tag color="magenta">برای تست</Tag>
                return <Tag color="cyan">غیر تستی </Tag>
            },
        },
        {
            width: 110,
            sorter: true, title: 'انتشار', dataIndex: 'published', key: 'published',
            render(val) {
                if (val) return <Tag color="green">منتشر شده</Tag>
                return <Tag color="red">عدم انتشار</Tag>
            },
        },
        // {
        //     defaultSortOrder: 'descend',
        //     sorter: true, title: 'زمان ایجاد', dataIndex: 'createdAt', key: 'createdAt', width: 110,
        //     render(val) {
        //         return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
        //     },
        // },
        {
            defaultSortOrder: 'descend',
            sorter: true, title: 'بروزرسانی', dataIndex: 'updatedAt', key: 'updatedAt', width: 170,
            render(val) {
                return moment(val).format('jYYYY/jMM/jDD H:mm:ss')
            },
        },

        {
            title: 'عملیات', dataIndex: '_id', key: '_id', width: 100,
            render(val) {
                return <Actions id={val}
                    // onEdit={(id: string) => navigate('/products-form?id=' + id)}
                    onDelete={onDeleteAction}>
                    <ProductDrower id={val} onEdit={onEditAction}  />
                </Actions>
            }
        },
    ];

    const fetchData = (params: Params) => {
        setIsLoaded(true);
        // console.log({ ...params, ...filters })
        restful.get(`/products/paginate`, { params: { ...params, ...filters } })
            .then((res) => {
                const result = res.data.result
                setItems(result.products);
                setPagination({
                    current: params.page,
                    pageSize: params.perPage,
                    total: result.productsCount,
                })
            })
            .catch((error) => {
                return notification.error({
                    message: 'Error ' + error.statusCode,
                    description: error.message,
                });
            })
            .finally(() => { setIsLoaded(false) })
    };

    useEffect(() => {
        fetchData({ sortDir: "desc", sort: "updatedAt", page: pagination.current, perPage: pagination.pageSize });
    }, [filters])

    const handleTableChange = (newPagination: TablePaginationConfig, filter: any, sorter: any) => {
        if (pagination.pageSize !== newPagination.pageSize) newPagination.current = 1
        fetchData({
            page: newPagination.current,
            perPage: newPagination.pageSize,
            sortDir: sorter.order === "ascend" ? "asc" : "desc",
            sort: sorter.field ?? "updatedAt"
        });
    };

    return <Table
        columns={columns}
        dataSource={items}
        loading={isLoaded}
        rowKey="_id"
        pagination={pagination}
        onChange={handleTableChange}
    />
}

export default ProducsTable


